module.exports = __webpack_public_path__ + "img/Skirt-Back-B4-Da-Fc-Gc-Hc-Ia-Ga.a86e05b7.png";